import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";
import Image from "../../elements/image";
import PrimaryButton from "../../elements/primary-button";
import PrimaryLink from "../../elements/primary-link";
import IconLink from "../../elements/icon-link";
import Heading from "../../elements/heading";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

export default class ListContentItem extends Component {
  constructor(props, context) {
    super(props, context);
    if (
      this.props.fields.subtitle &&
      !this.props.fields.subtitleType &&
      this.props.fields.subtitle.value
    ) {
      this.props.fields.subtitleType = { fields: { phrase: { value: "h4" } } };
      this.props.fields.subtitle.value = `<span class="type-h4">${this.props.fields.subtitle.value}</span>`;
    }
  }

  documentChange(model) {
    if (model.fields.headingBody) {
      let node = document.createElement("div");
      node.innerHTML = model.fields.headingBody.value;

      if (node.firstChild && node.firstChild.className === "") {
        node.firstChild.className = "type-h2";
        model.fields.headingBody.value = node.innerHTML;
      }
    }

    if (model.fields.subtitle && model.fields.subtitle.value) {
      let node2 = document.createElement("div");
      node2.innerHTML = model.fields.subtitle.value;

      if (node2.firstChild && node2.firstChild.className === "") {
        node2.firstChild.className = "type-h4";
        model.fields.subtitle.value = node2.innerHTML;
      }
    }
  }
  componentDidMount(props) {
    let model = this.props;
    this.documentChange(model);
  }

  render() {
    //let model = new ListContentItemModel(this.props);
    let model = this.props;

    // if (model.fields.headingBody) {
    //   let node = document.createElement("div");
    //   node.innerHTML = model.fields.headingBody.value;
    //
    //   if (node.firstChild && node.firstChild.className === "") {
    //     node.firstChild.className = "type-h2";
    //     model.fields.headingBody.value = node.innerHTML;
    //   }
    // }
    //
    // if (model.fields.subtitle) {
    //   let node2 = document.createElement("div");
    //   node2.innerHTML = model.fields.subtitle.value;
    //
    //   if (node2.firstChild && node2.firstChild.className === "") {
    //     node2.firstChild.className = "type-h4";
    //       model.fields.subtitle.value = node2.innerHTML;
    //   }
    // }

    const itemClasses = classNames(
      "list-content-item",
      "show-on-scroll",

      {
        top:
          (model.fields.itemAlignment &&
            model.fields.itemAlignment.fields.phrase.value) === "top"
      },
      {
        bottom:
          (model.fields.itemAlignment &&
            model.fields.itemAlignment.fields.phrase.value) === "bottom"
      },
      {
        center:
          (model.fields.itemAlignment &&
            model.fields.itemAlignment.fields.phrase.value) === "center"
      },
      {
        "center-text":
          (model.fields.itemTextAlignment &&
            model.fields.itemTextAlignment.fields.phrase.value) === "center"
      }
    );

    return (
      <div className={itemClasses}>
        {model.fields.spuId && <div ga-product-id={model.fields.spuId} />}
        {model.fields.overlineText && model.fields.overlineText.value && (
          <span className={"overline"}>{model.fields.overlineText.value}</span>
        )}
        {model.fields.image.value && model.fields.image.value.src && (
          <Image {...model.fields.image.value}></Image>
        )}
        {model.fields.iconName &&
          model.fields.iconName.value &&
          model.fields.iconName.value.alt && (
            // <i className="material-icons-sharp top-icon">
            //   {model.fields.iconName.fields.phrase.value}
            // </i>
            <RichText
              tag="span"
              className="top-icon"
              field={{ value: model.fields.iconName.value.alt }}
            />
          )}
        {model.fields.headingBody && (
          <Heading
            // type={model.heading.type}
            //
            // html={model.heading.text}
            {...{
              type: model.fields.headingType,
              html: model.fields.headingBody,
              typographyClass: "type-h3"
            }}
            className={"title"}
          />
        )}
        {model.fields.subtitle && model.fields.subtitle.value && (
          <Heading
            // type={model.subheading.type}
            // className={"subtitle"}
            // html={model.subheading.text}
            {...{
              type: model.fields.subtitleType,
              html: model.fields.subtitle,
              typographyClass: "type-h4"
            }}
            className={"subtitle"}
          />
        )}
        {model.fields.body && model.fields.body.value && (
          <RichText tag="div" className="body-text" field={model.fields.body} />
        )}
        {model.fields.bulletListItems &&
          model.fields.bulletListItems.length !== 0 && (
            <div className={"body-text"}>
              <ul>
                {model.fields.bulletListItems.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.fields.iconName &&
                        item.fields.iconName.value &&
                        item.fields.iconName.value.alt && (
                          <RichText
                            field={{ value: item.fields.iconName.value.alt }}
                          />
                        )}
                      {item.fields.body && item.fields.body.value}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        {model.fields.buttonHeading &&
          model.fields.buttonHeading.value !== "" && (
            <span className={"button-heading"}>
              {model.fields.buttonHeading.value}
            </span>
          )}
        {model.fields.CTA &&
          model.fields.CTA.length > 0 &&
          model.fields.CTA.map(
            (item, index) =>
              item.fields &&
              item.fields.ctatype &&
              item.fields.ctatype.fields &&
              ((item.fields.ctatype.fields.phrase.value === "primary-link" && (
                <PrimaryLink key={index} {...item.fields} />
              )) ||
                (item.fields.ctatype.fields.phrase.value ===
                  "primary-button" && (
                  <PrimaryButton key={index} {...item.fields} />
                )) ||
                (item.fields.ctatype.fields.phrase.value === "icon-link" && (
                  <IconLink key={index} {...item.fields} />
                )))
          )}
      </div>
    );
  }
}
